export class ZoneDeTravailAvecSiteDto {
	id: number;
	nom: string;
	nomDuSite: string;

	constructor(id: number, nom: string, nomDuSite: string) {
		this.id = id;
		this.nom = nom;
		this.nomDuSite = nomDuSite;
	}
}
